"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var CurvedArrowLeft = function CurvedArrowLeft(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "38.788",
    height: "7.363",
    viewBox: "0 0 38.788 7.363"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-212.336 -763.629)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    d: "M10679.457-10721.706a49.361,49.361,0,0,1-37.411,0",
    transform: "translate(-10429 11488)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    strokeLinejoin: "round",
    d: "M10646.28-10723.706l-4.325,2.022,1.394,4.04",
    transform: "translate(-10429 11488)"
  })));
};

CurvedArrowLeft.propTypes = {};
CurvedArrowLeft.defaultProps = {};
var _default = CurvedArrowLeft;
exports["default"] = _default;